
import levenshteinDistance from './levenshteinDistance'

export const updateMultipleTextFields = (
    questionAnswerValue: any,
    spokenAnswer: String,
    finalSpokenAnswer: String,
    questionFieldNames: Array<string>,
    lastMultiTextFieldFromSpeech: string | null,
    setLastMultiTextFieldFromSpeech: React.Dispatch<React.SetStateAction<string | null>>
) => {



    const updatedQuestionAnswerValues = questionAnswerValue ? { ...questionAnswerValue } : {}

 

    let matchedFieldName: string | null = null
    const normalizedAnswer = finalSpokenAnswer.trim().toLowerCase()

    // 1. Check if any of the spoken words matches a field name
    for (const option of questionFieldNames) {
        const lowercaseOption = option.toLowerCase()
        const distance = levenshteinDistance(lowercaseOption, normalizedAnswer)
        const threshold = lowercaseOption.length <= 4 ? 1 : 2
        // console.log(`distance between "${lowercaseOption}" and "${normalizedAnswer}": ${distance}. Threshold: ${threshold}`)
        if (distance < threshold) {
            matchedFieldName = option
        }
    }

    // 2. Check if any single word uniquely identifies one field 
    if (!matchedFieldName) {
        const answerWords = normalizedAnswer.split(/\s+/)

        for (const word of answerWords) {
            const matches = questionFieldNames.filter(option =>
                option.toLowerCase().split(" ").includes(word)
            )
            // If exactly one option matches this word, return it -
            // this is because we might have 'big flood, small flood' 'major alert, minor alert' 'not radioactive' 'very radioactive' etc
            if (matches.length === 1) {
                matchedFieldName = matches[0]
                break
            }
        }
    }

    if (matchedFieldName) {
        //console.log(`✅ Spoken text: ${spokenAnswer} matched field name: ${matchedFieldName}`)
        setLastMultiTextFieldFromSpeech(matchedFieldName)
    }

    else if (!matchedFieldName && lastMultiTextFieldFromSpeech) {
        //console.log(`✅ Spoken text: ${spokenAnswer} applied to field name: ${lastMultiTextFieldFromSpeech}`)
        updatedQuestionAnswerValues[lastMultiTextFieldFromSpeech] = spokenAnswer
        //setLastMultiTextFieldFromSpeech(null)
    }

    else if (!lastMultiTextFieldFromSpeech) {
        const firstFieldOption = questionFieldNames[0]
        setLastMultiTextFieldFromSpeech(firstFieldOption)
    }

    else {
        console.log(`⛔️ No matching field name found for spoken text: ${spokenAnswer}`)
    }

    return updatedQuestionAnswerValues
}

